// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-select--none {\n  user-select: none; }\n\n.user-select--initial {\n  user-select: initial; }\n\n.delete-my-images {\n  margin: 0px 16px 5px; }\n\n.delete-my-images-footer-button {\n  width: 35px !important;\n  height: 35px !important;\n  padding: 0 !important;\n  text-align: center; }\n  .delete-my-images-footer-button i {\n    padding-top: 5px;\n    width: 35px; }\n", ""]);
// Exports
module.exports = exports;
